export const DEFAULT_PAYMENTS_RESPONSE_KEY = "show_payments";

// sid key to store in STORAGE to show offer bundle half card once in a session
export const OFFER_BUNDLE_HALF_CARD_SID = "sid_for_which_half_card_is_visible";

/** This key is to store the Auto add XP plan type */
export const AUTO_ADD_OR_ONE_TAP_PLAN_TYPE_SESSION_KEY = "auto_add_or_one_tap_plan_session_key";

export const IS_IRCTC_CART_SESSION_KEY = "is_irctc_cart_session_key";

// sid to store the session id for which the one membership gratification is shown
export const ONE_MEMBERSHIP_GRATIFICATION_SID = "gratification_modal_sid";

export const ONE_MEMBERSHIP_PLAN_ADDITION_CONFETTI_SID = "one_membership_plan_addition_confetti_sid";

// localStorage key used by web-bridge-sdk for mweb cart
export const SWGY_PWA_CART_DATA = "swgy_pwa_cartData";
export const WEB_FOOD_CART_LOCAL = "web_food_cart_local";